/* eslint-disable import/prefer-default-export */
import { ScriptHTMLAttributes } from 'react';

export const createScriptNode = (
  props: ScriptHTMLAttributes<HTMLScriptElement> & {
    onload?: () => void;
  }
): HTMLElement => {
  const scriptNode: HTMLScriptElement = document.createElement('script');
  scriptNode.type = 'text/javascript';
  Object.keys(props).forEach((key) => {
    const keyName = key as keyof typeof props;
    // TODO: fix to proper typing
    (scriptNode as any)[keyName] = props[keyName];
  });
  return scriptNode;
};
